import { storageFileApi } from "./axios";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import {
  ServiceResponseI,
  StorageFileResponseI,
  StorageFileUsageByClientI,
  StorageFileUsageByEquipmentI,
} from "../../interfaces";
import { AxiosError } from "axios";

export const storageGetUsageByClient = async (
  clientId?: number,
): Promise<ServiceResponseI<StorageFileUsageByClientI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();
    if (clientId) params.append("client", `${clientId}`);

    const { data } = await storageFileApi.get<
      ServiceResponseI<StorageFileUsageByClientI[]>
    >("/usage/by-client", {
      params,
      headers: { Authorization: validateToken },
    });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const storageGetUsageByEquipment = async (
  clientId: number,
): Promise<ServiceResponseI<StorageFileUsageByEquipmentI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await storageFileApi.get<
      ServiceResponseI<StorageFileUsageByEquipmentI[]>
    >(`/usage/by-equipment/${clientId}`, {
      headers: { Authorization: validateToken },
    });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

// ── AGREGAR al final del archivo existente ──────────────────────────────────

export const storageGetByEquipment = async (
  equipmentId: number,
): Promise<ServiceResponseI<StorageFileResponseI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await storageFileApi.get<
      ServiceResponseI<StorageFileResponseI[]>
    >(`/entity/equipment/${equipmentId}`, {
      headers: { Authorization: validateToken },
    });

    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const storageUploadEquipmentFiles = async (
  equipmentId: number,
  files: { name: string; base64: string }[],
): Promise<ServiceResponseI<StorageFileResponseI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await storageFileApi.post<
      ServiceResponseI<StorageFileResponseI[]>
    >(
      "/upload",
      { entityType: "equipment", entityId: equipmentId, equipmentId, files },
      { headers: { Authorization: validateToken } },
    );

    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const storageDeleteFile = async (
  fileId: number,
): Promise<ServiceResponseI<string>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await storageFileApi.delete<ServiceResponseI<string>>(
      `/${fileId}`,
      { headers: { Authorization: validateToken } },
    );

    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};
